// extracted by mini-css-extract-plugin
export default {"botao":"botao_botao__ymvrx","primary":"botao_primary__O1EPo","secondary":"botao_secondary__2mpfd"};